define('modules/home/dashboard/views/dashboard.main.view',[
    'client',
    "bootstrapSwitch",
    'jquery',
    'underscore',
    'backbone',
    'marionette',
    "modules/base/models/contact.search.model",
    'modules/base/views/base.search.reset.view',
    "text!modules/home/dashboard/templates/main.template.html",
    'modules/base/views/base.view'
], function(
    Prospector,
    BootstrapSwitch,
    $,_,Backbone,
    Marionette,
    ContactSearchModel,
    BaseSearchResetView,
    Template,
    BaseView
){
    var MainView = BaseView.extend({
        template: _.template(Template),
        className: 'container-fluid searchPage',
        searchSize: 5,
        abortable: true,
        initialize: function(options) {
            BaseView.prototype.initialize.apply(this, options);
            this.state = false;
            this.model = null;
        },
        mEvents: function(){
            var base = {
                'keyup .mainSearch input' : 'buildSearch',
                'paste .mainSearch input': 'procSearch',
                 'click .reset_icon'    : 'procSearch'
            };
            var click = {
                "click .searchBtn"               : "procSearch",
                "click .resetBtn, .resetBtnDrawer" : "resetSearch",
                "click .oldVersion" : "oldVersion",
                'click .createPersonContact' : 'procCreatePersonContact',
                'click .createCompanyContact' : 'procCreateCompanyContact'
            };
            $.extend(base,click);
            return base;
        },

        onRender: function() {
            this.$('.userFirstName').html(window.user.get('firstName'));
            this.$('#searchToggle').bootstrapSwitch({onText: 'Yes', offText: 'No', onColor: 'primary', offColor:'primary'}).on('switchChange.bootstrapSwitch', $.proxy(function(event, state) {
                this.toggleSearch(event);
            }, this));
            //fill submenu with upgrade btn view if trial user
            Prospector.trigger("showTrialSubMenu");

            this.resetViews = [];

            //render 4 text field views
            var baseSearchResetView = new BaseSearchResetView();
            this.$('.main').append(baseSearchResetView.render().el);
            this.$('.main input').attr("placeholder", "Search for people and companies");
            this.resetViews.push(baseSearchResetView);

            var baseSearchResetView2 = new BaseSearchResetView();
            this.$('.lastName').append(baseSearchResetView2.render().el);
            this.$('.lastName input').attr("placeholder", "Last Name");
            this.resetViews.push(baseSearchResetView2);

            var baseSearchResetView3 = new BaseSearchResetView();
            this.$('.companyName').append(baseSearchResetView3.render().el);
            this.$('.companyName input').attr("placeholder", "Company Name");
            this.resetViews.push(baseSearchResetView3);

            var baseSearchResetView4 = new BaseSearchResetView();
            this.$('.titleRole').append(baseSearchResetView4.render().el);
            this.$('.titleRole input').attr("placeholder", "Title Role");
            this.resetViews.push(baseSearchResetView4);

        },
        getStringValue:function(str){
            if(str == null || str == undefined){
                return '';
            } else {
                return str;
            }
        },
        toggleSearch:function(event){
            if(this.$('#searchToggle').bootstrapSwitch('state')){
                this.$('.searchInputHolder').addClass('toggled');
                this.$('.main input').attr("placeholder", "First Name");
            } else {
                this.$('.searchInputHolder').removeClass('toggled');
                this.$('.main input').attr("placeholder", "Search for people and companies");
            }
        },
        getInputString:function(){
            var val = "";
            if(this.$('#searchToggle').bootstrapSwitch('state')){
                val = this.$('.main input').val();
                val += this.$('.lastName input').val();
                val += this.$('.companyName input').val();
                val += this.$('.titleRole input').val();

            } else {
                val = this.$('.main input').val();
            }

            return $.trim(val);
        },
        buildInputTextCombo:function(){

        },
        buildSearch:function(event){
            event.stopPropagation();
            var inp = String.fromCharCode(event.keyCode);
            if (/[a-zA-Z0-9-]/.test(inp) || event.keyCode == 8 || event.keyCode == 91 || event.keyCode == 32){
                if(this.$('.helloMsg').css('display') != 'none'){
                    this.$('.helloMsg').slideUp();
                }
                this.procSearch();
            } else if(event.keyCode == 13){
                var val = this.getInputString();
                if (val.length > 2) {
                    Prospector.trigger("openSideDrawer", {
                        passedFunc: function () {
                            $(".verticalIcon").removeClass('active');
                            $(".verticalIcon.search").addClass('active');
                            $('.searchViewHolder').show();
                        }
                    });
                    this.sendToSubApp();
                }
            }
        },
        resetSearch:function() {
            this.$('.main input').val("");
            this.$('.main .reset_icon').hide();
            this.$('.lastName input').val("");
            this.$('.lastName .reset_icon').hide();
            this.$('.companyName input').val("");
            this.$('.companyName .reset_icon').hide();
            this.$('.titleRole input').val("");
            this.$('.titleRole .reset_icon').hide();
            window.utils.clearSessionStorage();

            this.$('.searchResults').hide();
            this.$('.peopleResults').empty();
            this.$('.orgResults').empty();

            _.each(this.resetViews, function(rsv){
                rsv.resetShow();
            }, this);
            Prospector.trigger('updateBadgeCount', {
                name: "search",
                count: 0
            });
            $(this.el).removeClass('results');
        },
        procSearch:function(session){
            var val = this.getInputString();
            if (val.length > 2) {
                window.setTimeout(
                    $.proxy(
                        this.procTimeBuildSearch,
                        this, val, session),
                    window.typeAheadWait + Math.ceil(100 * Math.random()));
            }
            else {
                this.$('.searchResults').hide();
                $(this.el).removeClass('results');
                Prospector.trigger('updateBadgeCount', {
                    name: "search",
                    count: 0
                });
            }
        },
        procTimeBuildSearch:function(val){
            if(val == this.getInputString()){
                this.contactSearchModel = new ContactSearchModel();
                this.contactSearchModel.state = this.$('#searchToggle').bootstrapSwitch('state');
                this.contactSearchModel.pageSize = this.searchSize;
                if(this.$('#searchToggle').bootstrapSwitch('state')){
                    this.contactSearchModel.firstName = this.getStringValue(this.$('.main input').val());
                    this.contactSearchModel.lastName = this.getStringValue(this.$('.lastName input').val());
                    this.contactSearchModel.orgName = this.getStringValue(this.$('.companyName input').val());
                    this.contactSearchModel.title = this.getStringValue(this.$('.titleRole input').val());
                } else {
                    this.contactSearchModel.query = val;
                }
                this.cleanMySubviews();
                this.showLoader();
                this.contactSearchModel.bind('sync', this.procBuildSearch, this);
                this.contactSearchModel.fetch();
            }
        },
        showLoader:function(){
            this.$('.home_ripple').show();
            this.$('.searchResults').show();
            this.$('.searchResultsHolder').show();
            this.$('.search_results_label').hide();
            this.$('.peopleResults').empty();
            this.$('.orgResults').empty();
        },
        hideLoader:function(){
            this.$('.home_ripple').hide();
            this.$('.peopleResults').empty();
            this.$('.search_results_label').show();
            this.$('.searchResults').remove('.home_ripple');
            this.$('.orgResults').empty();
            this.$('.searchResultsHolder').show();
        },
        procBuildSearch:function(){
            this.hideLoader();
            if(this.contactSearchModel.isValid()){
                this.buildPeopleResults();
                this.buildOrgResults();
            } else {
                this.$('.searchResults').fadeOut();
                this.errOut(this.contactSearchModel.errorMessage);
            }
            this.sendToSubApp();
        },
        sendToSubApp:function(){
            var options = {
                state: !this.$('#searchToggle').bootstrapSwitch('state'),
                main: this.getStringValue(this.$('.main input').val()),
                lastName: this.getStringValue(this.$('.lastName input').val()),
                companyName: this.getStringValue(this.$('.companyName input').val()),
                titleRole: this.getStringValue(this.$('.titleRole input').val())
            }
            Prospector.trigger('runSubSearch', options);
        },
        buildPeopleResults:function(){
            this.subviews.push(new Array());
            this.buildPeopleCollectionViews(this.contactSearchModel.get('individuals'));
        },
        buildPeopleCollectionViews:function(collection){
            this.indivCount = 0;
            if(collection != undefined && collection.length > 0){
                this.indivCount = collection.length;
                this.buildCollectionViews(collection, '.peopleResults', 'person', 0);
            } else{
                this.$('.home.peopleResults').append("<div class='col-md-10 noResults'>There are no people matching your search criteria.</div>");
                this.$('.drawer.peopleResults').append("<div class='noResults animated fadeIn'>There are no people matching your search criteria.</div>");
            }
        },
        buildCollectionViews:function(collection, viewHolder, type, index){
            var that = this;
            var i = 0;
            require(['modules/home/dashboard/views/search.result.view'],
                function(SearchResultView) {
                    _.each(collection, function (model) {
                        if(that.$(viewHolder).children().length < that.searchSize){
                            model.identityType = type;
                            var srv = new SearchResultView({model: model, filter: that.getFilter(), sequence: i, parent: that});
                            that.$(viewHolder).append(srv.render().el);
                            if(that.subviews[index] != undefined){
                                that.subviews[index].push(srv);
                            }
                            i++;
                        }
                    }, that);
                    $(that.el).addClass('results');
                });
        },
        buildOrgResults:function(){
            this.subviews.push(new Array());
            this.buildOrgCollectionViews(this.contactSearchModel.get('organizations'));
        },
        buildOrgCollectionViews:function(collection){
            this.orgCount = 0;
            if(collection != undefined && collection.length > 0){
                this.orgCount = collection.length;
                this.buildCollectionViews(collection, '.orgResults', 'organization', 1);
            } else{
                this.$('.home.orgResults').append("<div class='col-md-10 noResults'>There are no companies matching your search criteria.</div>");
                this.$('.drawer.orgResults').append("<div class='noResults animated fadeIn'>There are no companies matching your search criteria.</div>");
            }
        },
        updateCount:function(){
            Prospector.trigger('updateBadgeCount', {
                name: "search",
                count: this.indivCount + this.orgCount
            });
        },
        getFilter: function(){
            return '';
        },
        oldVersion:function(){
            window.location.href = window.entitlements.get('RelProV1');
        },
        procCreatePersonContact:function(){
            Prospector.trigger('createPerson',{
                main : this.getStringValue(this.$('.main input').val()),
                lastName : this.getStringValue(this.$('.lastName input').val()),
                company : this.getStringValue(this.$('.companyName input').val()),
                title : this.getStringValue(this.$('.titleRole input').val()),
                state: this.$('#searchToggle').bootstrapSwitch('state')
            });
        },
        procCreateCompanyContact:function(){
            Prospector.trigger('createCompany',{
                main : this.getStringValue(this.$('.main input').val()),
                lastName : this.getStringValue(this.$('.lastName input').val()),
                company : this.getStringValue(this.$('.companyName input').val()),
                title : this.getStringValue(this.$('.titleRole input').val()),
                state: this.$('#searchToggle').bootstrapSwitch('state')
            });
        }
    });
    return MainView;
});
